<template>
  <a-input
    v-model:value="innerValue"
    :placeholder="placeholder"
    :disabled="disabled"
    :size="size"
    :allow-clear="allowClear"
    :maxlength="maxlength"
    :status="status"
    :prefix="prefix"
    :suffix="suffix"
    class="ant-text-input"
    @blur="onBlur"
    @pressEnter="onPressEnter"
  >
    <template v-if="prefixIcon" #prefix>
      <i :class="prefixIcon" />
    </template>
    <template v-if="suffixIcon" #suffix>
      <i :class="suffixIcon" />
    </template>
  </a-input>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  maxlength?: number;
  status?: "" | "error" | "warning";
  prefix?: string;
  suffix?: string;
  prefixIcon?: string;
  suffixIcon?: string;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: "",
  placeholder: "",
  disabled: false,
  size: "middle",
  allowClear: true,
  maxlength: undefined,
  status: "",
  prefix: undefined,
  suffix: undefined,
  prefixIcon: "",
  suffixIcon: "",
});

const emit = defineEmits<{
  (e: "update:modelValue", value: string): void;
  (e: "blur", event: FocusEvent): void;
  (e: "pressEnter", event: KeyboardEvent): void;
  (e: "change", value: string): void;
}>();

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onBlur = (e: FocusEvent) => emit("blur", e);
const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);
</script>

<!--
  Hướng dẫn sử dụng — Text Input
  Global: <h-input v-model="name" placeholder="Họ tên" />
  Import: import { InputDefault } from '@/components/ant/input'

  Props: modelValue, placeholder, disabled, size, allowClear, maxlength, status, prefixIcon, suffixIcon
  Events: update:modelValue, change, blur, pressEnter
  Docs: src/components/ant/input/README.md
-->
